import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';

export default {
    async getPlatformApprovalData({ commit }) {
        try {
            const endpoint = '/seccl/client/approvalcheck';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);

            commit('setPlatformApprovalData', response);
            return response;
        } catch (error) {
            console.error('Error fetching platform approval data:', error);
            commit('setPlatformApprovalData', null);
            return null;
        }
    },

    async submitPlatformApproval(_context, payload) {
        try {
            const endpoint = '/seccl/client/approval';
            const response = await api.post(`${toDrupalRequest(endpoint)}`, payload);

            return response;
        } catch (error) {
            console.error('Error submitting platform approval:', error);
            throw error;
        }
    },
};
